import { Input as AntInput } from "antd";
import React, { useMemo } from "react";
import styled from "styled-components";
import Text from "../text";

const Styled = styled.div`
  border-radius: 20px;
  background-color: ${(_) => _.theme.token.surface.primary};
  padding: 1.5rem 1.5rem;
  label > * {
    margin-bottom: 1rem !important;
  }
  .ant-select {
    height: 2.2rem;
    .ant-select-selector {
      border: none !important;
      background-color: transparent !important;
      padding: 0px;
      box-shadow: unset !important;
      inset-inline: unset;
      .ant-select-selection-search {
        inset-inline: unset;
        width: 100%;
      }
    }
  }
  ${(_) =>
    _.outlined &&
    `border: 1px solid black;
    border-radius: 1rem;
    padding: 1rem;
    background: transparent;
  `}
  textarea {
    resize: none;
    padding: 0px;
    border: none !important;
    box-shadow: unset !important;
    background: transparent !important;
  }
  .ant-input,
  .ant-input-password input {
    &::placeholder {
      font-weight: 300 !important;
      line-height: 1.9rem;
    }
  }
  .ant-select-selection-placeholder {
    font-weight: 300 !important;
    line-height: 1.9rem;
  }
`;

const Input = ({
  label = "",
  children,
  style,
  className,
  styles = { input: {} },
  outlined = false,
  ...props
}) => {
  const isRequired = useMemo(
    () => !!(props?.rules ?? []).filter((_) => _.required)?.length,
    [props.rules]
  );

  const renderInput = () => {
    if (!!children) return children;
    if (props.type === "password")
      return (
        <AntInput.Password
          {...props}
          style={{ all: "unset", display: "flex" }}
        />
      );
    else if (props.type === "textarea")
      return <AntInput.TextArea rows={7} {...props} />;
    return (
      <AntInput
        {...props}
        style={{
          all: "unset",
          width: "100%",
          ...(styles?.input ?? {}),
        }}
      />
    );
  };

  return (
    <Styled outlined={outlined} style={style} className={className}>
      {!!label && (
        <label htmlFor={props.id}>
          <Text
            weight={"600"}
            color="secondary"
            children={`${label}${isRequired ? "*" : ""}`}
          />
        </label>
      )}
      {renderInput()}
    </Styled>
  );
};

export default Input;
